export default __webpack_public_path__ + "static/media/975.fbcf1295.png";